import {connect} from 'react-redux'

import {ModalSendOfferDetailsEmp} from './ModalSendOfferDetailsEmp'

export const ModalSendOfferDetailsEmpContainer = connect(
  null,
  null
)(ModalSendOfferDetailsEmp)
